// @core/api/endpoints/secret/health.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  HealthResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Health check
 * Returns health status including initialization state, seal status, and service version. Always returns 200 for monitoring. Safe to call when sealed.
 * @public This endpoint does not require authentication
 */
export async function Health(
  params?: {
  },
  options?: RequestOptions
): Promise<HealthResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/sys/health`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<HealthResponse>(requestPath, { ...requestOptions, params });
}
